import React from 'react';

import { Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from 'next/image';


export const BookOverview = React.forwardRef(function BookOverview() {
  const imageContext = require.context('public/whoWeAre/books', false);
  const imageArr = imageContext.keys();
  
  const itemCount = imageArr.length;

  return (
    <Swiper 
      modules={[Autoplay]}
      loop
      centeredSlides
      loopedSlides={itemCount}
      autoplay={{
        delay: 4000,
      }}
    >
      {
        imageArr.map(img => 
          <SwiperSlide key={img}>
            <img alt='collection of image books' src={`/whoWeAre/books/${img.slice(2)}`} />
          </SwiperSlide>
        )
      }
    </Swiper> 
  );
});
